import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom"; // Importando useNavigate
import {
  Button,
  Container,
  Divider,
  SubTitle,
  Title,
  TitleRed,
} from "./styles";

import { useUser } from "../../contexts/UserContext";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function AuthCode() {
  const { t } = useTranslation();
  const navigate = useNavigate(); // Criando o hook de navegação
  const { handleLogin, alert, setAlert } = useUser();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Lógica de login
  const handleInsert = async () => {
    if (!email || !password) {
      setAlert("Favor insira os dados corretamente!!");
      return;
    }
    handleLogin(email, password);
  };

  return (
    <Container>
      <Title>Login</Title>
      <SubTitle>
        <Translator path="paginas.authCode.Subtitle" />
      </SubTitle>
      <Divider />

      <Box component="form" sx={{ maxWidth: "100%" }} noValidate>
        <TextField
          required
          fullWidth
          sx={{ marginY: "15px" }}
          type="text"
          autoComplete="off"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
          variant="filled"
          placeholder="Digite seu email"
        />
        <TextField
          required
          fullWidth
          sx={{ marginY: "15px" }}
          type="password"
          autoComplete="off"
          value={password}
          onChange={(e) => setPassword(e.target.value.trim())}
          variant="filled"
          placeholder="Digite sua senha"
        />
      </Box>

      <Button onClick={handleInsert}>Login</Button>

      {/* Botão de Cadastrar que muda de página sem abrir nova aba */}
      <Button
        onClick={() => navigate("/cadastrar")} // Navegando para a tela de cadastro
        sx={{ marginTop: "10px", backgroundColor: "#ccc", color: "#000" }}
      >
        <Translator path="paginas.authCode.linkRegistro" />
      </Button>

      {alert && <TitleRed>{alert}</TitleRed>}
    </Container>
  );
}
